﻿var mmsystem = mmsystem || {};
mmsystem.ui = mmsystem.ui || {};

//Node imports
//mmsystem.core = require('mmsystem-core');
//var $ = jQuery = mmsystem.core.$;
var events = require('events');

mmsystem.ui.ajax = {

    Language: "En",
    LanguageUrlPrefix: "En",
    UseGlobalization: false,
    EventEmitter: new events.EventEmitter(),

    Init: function (lang, useGlobalization) {
        this.Language = typeof lang !== "undefined" ? lang : this.Language;
        this.UseGlobalization = typeof useGlobalization !== "undefined" ? useGlobalization : this.UseGlobalization;
        this.LanguageUrlPrefix = this.UseGlobalization ? "/" + lang : "";
    },

    LoginUser: function (loginModel) {
        
        $.ajax({
            url: mmsystem.ui.ajax.LanguageUrlPrefix + '/Account/Login',
            type: "POST",
            dataType: "json",
            //contentType: "application/json; charset=utf-8",
            data: loginModel,
            success: function (result) {
                
            },
            error: function (result) {
                mmsystem.ui.ajax.EventEmitter.emit("serverError", result);
            },
            complete: function (result) {
                // Add Event
                //console.log('Emit "loginUserComplete" Event');
                //$(mmsystem.ui.ajax).trigger("loginUserComplete", result);
                mmsystem.ui.ajax.EventEmitter.emit('loginUserComplete', result);
            }
        });
    },

    LogoutUser: function () {

        $.ajax({
            url: mmsystem.ui.ajax.LanguageUrlPrefix + '/Account/Logout',
            type: "POST",
            dataType: "json",
            //contentType: "application/json; charset=utf-8",
            //data: loginModel,
            success: function (result) {

            },
            error: function (result) {
                mmsystem.ui.ajax.EventEmitter.emit("serverError", result);
            },
            complete: function (result) {
                // Add Event
                //console.log('Emit "logoutUserComplete" Event');
                //$(mmsystem.ui.ajax).trigger("logoutUserComplete", result);
                mmsystem.ui.ajax.EventEmitter.emit('logoutUserComplete', result);
            }
        });
    },

    SendResetUserPasswordLink: function (email) {

        $.ajax({
            url: mmsystem.ui.ajax.LanguageUrlPrefix + '/Account/SendResetPasswordLink',
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify({ email: email }),
            success: function (result) {

            },
            error: function (result) {
                mmsystem.ui.ajax.EventEmitter.emit("serverError", result);
            },
            complete: function (result) {
                // Add Event
                //console.log('Emit "sendResetUserPasswordLinkComplete" Event');
                //$(mmsystem.ui.ajax).trigger("sendResetUserPasswordLinkComplete", result);
                mmsystem.ui.ajax.EventEmitter.emit('sendResetUserPasswordLinkComplete', result);
            }
        });
    },

    SaveParent: function (url, itemId, parentId) {
        $.ajax({
            url: url,
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify({ id: itemId, parentId: parentId }),
            success: function (result) {
                //toastr.success(result + " Category Saved", "Success");
            },
            error: function (result) {
                mmsystem.ui.ajax.EventEmitter.emit("serverError", result);
            },
            complete: function (result) {
                // Add Event
                //console.log('Add "saveParentComplete" Event');
                //$(mmsystem.ui.ajax).trigger("saveParentComplete", result); // SimpleResult { Type: '0', Message: '' } success - 1, error - 2
                mmsystem.ui.ajax.EventEmitter.emit('saveParentComplete', result);
            }
        });
    },

    SaveListingOrder: function (url, object) {
        $.ajax({
            url: url,
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(object),
            success: function (result) {
                //toastr.success(result + "Category Listing Order Saved", "Success");
            },
            error: function (result) {
                mmsystem.ui.ajax.EventEmitter.emit("serverError", result);
            },
            complete: function (result) {
                // Add Event
                //console.log('Emit "saveListingOrderComplete" Event');
                //$(mmsystem.ui.ajax).trigger("saveListingOrderComplete", result); // SimpleResult { Type: '0', Message: '' } success - 1, error - 2
                mmsystem.ui.ajax.EventEmitter.emit('saveListingOrderComplete', result);
            }
        });
    },

    SaveCategory: function (url, category) {
        console.log("mmsystem.ui.ajax SaveCategory...");
        $.ajax({
            url: url,
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(category),
            success: function (result) {

            },
            error: function (result) {
                mmsystem.ui.ajax.EventEmitter.emit("serverError", result);
            },
            complete: function (result) {
                // Add Event
                //console.log('Emit "saveCategoryComplete" Event');
                //$(mmsystem.ui.ajax).trigger("saveCategoryComplete", result); // SimpleResult { Type: '0', Message: '' } success - 1, error - 2
                mmsystem.ui.ajax.EventEmitter.emit('saveCategoryComplete', result);
            }
        });
    },

    CropImage: function (url, data) {
        console.log("mmsystem.ui.ajax CropImage...");
        $.ajax({
            url: url,
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(data),
            success: function (result) {

            },
            error: function (result) {
                mmsystem.ui.ajax.EventEmitter.emit("serverError", result);
            },
            complete: function (result) {
                // Add Event
                //console.log('Emit "cropImageComplete" Event');
                //$(mmsystem.ui.ajax).trigger("cropImageComplete", result); // SimpleResult { Type: '0', Message: '' } success - 1, error - 2
                mmsystem.ui.ajax.EventEmitter.emit('cropImageComplete', result);
            }
        });
    },

    OrderGetItemHtmlRow: function (url, data) {
        //console.log("mmsystem.ui.ajax Order.OrderGetItemHtmlRow...");
        $.ajax({
            url: url,
            type: "GET",
            dataType: "json",
            //contentType: "application/json; charset=utf-8",
            data: data,
            success: function (result) {

            },
            error: function (result) {
                mmsystem.ui.ajax.EventEmitter.emit("serverError", result);
            },
            complete: function (result) {
                //$(mmsystem.ui.ajax).trigger("orderGetItemHtmlRow", result); // SimpleResult { Type: '0', Message: '' } success - 1, error - 2
                mmsystem.ui.ajax.EventEmitter.emit('orderGetItemHtmlRow', result);
            }
        });
    },

    OrderUpdateItem: function (url, data) {
        console.log("mmsystem.ui.ajax Order.OrderUpdateItem...");
        $.ajax({
            url: url,
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(data),
            success: function (result) {

            },
            error: function (result) {
                mmsystem.ui.ajax.EventEmitter.emit("serverError", result);
            },
            complete: function (result) {
                // Add Event
                console.log('Emit "orderUpdateComplete" Event');
                //$(mmsystem.ui.ajax).trigger("orderUpdateComplete", result); // SimpleResult { Type: '0', Message: '' } success - 1, error - 2
                mmsystem.ui.ajax.EventEmitter.emit('orderUpdateComplete', result);
            }
        });
    },

    OrderCheckDiscountCode: function (url, data) {
        //console.log("mmsystem.ui.ajax Order.orderCheckDiscountCodeComplete...");
        $.ajax({
            url: url,
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(data),
            success: function (result) {

            },
            error: function (result) {
                mmsystem.ui.ajax.EventEmitter.emit("serverError", result);
            },
            complete: function (result) {
                // Add Event
                console.log('Emit "orderCheckDiscountCodeComplete" Event');
                //$(mmsystem.ui.ajax).trigger("orderCheckDiscountCodeComplete", result); // SimpleResult { Type: '0', Message: '' } success - 1, error - 2
                mmsystem.ui.ajax.EventEmitter.emit('orderCheckDiscountCodeComplete', result);
            }
        });
    },

    OrderUpdateNote: function (url, data) {
        //console.log("mmsystem.ui.ajax Order.OrderUpdateNote...");
        $.ajax({
            url: url,
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(data),
            success: function (result) {

            },
            error: function (result) {
                mmsystem.ui.ajax.EventEmitter.emit("serverError", result);
            },
            complete: function (result) {
                // Add Event
                //console.log('Emit "orderUpdateNoteComplete" Event');
                //$(mmsystem.ui.ajax).trigger("orderUpdateNoteComplete", result); // SimpleResult { Type: '0', Message: '' } success - 1, error - 2
                mmsystem.ui.ajax.EventEmitter.emit('orderUpdateNoteComplete', result);
            }
        });
    },

    OrderGetDeliveryMethods: function (url, data) {
        //console.log("mmsystem.ui.ajax Order.OrderUpdateNote...");
        $.ajax({
            url: url,
            type: "GET",
            //dataType: "json",
            //contentType: "application/json; charset=utf-8",
            data: data,
            success: function (result) {

            },
            error: function (result) {
                mmsystem.ui.ajax.EventEmitter.emit("serverError", result);
            },
            complete: function (result) {
                // Add Event
                console.log(result);
                // Build Simple Object result as this is NOT Json dataType but text
                mmsystem.ui.ajax.EventEmitter.emit('OrderGetDeliveryMethods', { Type: 1, Object: { RawHtml: result.responseText } });
            }
        });

    },

    GetOrder: function (url, data) {
        //console.log("mmsystem.ui.ajax Order.GetOrder...");
        $.ajax({
            url: url,
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(data),
            success: function (result) {

            },
            error: function (result) {
                mmsystem.ui.ajax.EventEmitter.emit("serverError", result);
            },
            complete: function (result) {
                // Add Event
                //console.log('Emit "orderUpdateComplete" Event');
                //$(mmsystem.ui.ajax).trigger("orderUpdateComplete", result); // SimpleResult { Type: '0', Message: '' } success - 1, error - 2
                mmsystem.ui.ajax.EventEmitter.emit('orderUpdateComplete', result);
            }
        });
    },

    GetCheckoutDetails: function (url, data) {
        //console.log("mmsystem.ui.ajax Order.GetCheckoutDetails...");
        $.ajax({
            url: url,
            type: "GET",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: data,
            success: function (result) {

            },
            error: function (result) {
                mmsystem.ui.ajax.EventEmitter.emit("serverError", result);
            },
            complete: function (result) {
                // Add Event
                //console.log('Emit "getCheckoutDetailsComplete" Event');
                //$(mmsystem.ui.ajax).trigger("orderUpdateComplete", result); // SimpleResult { Type: '0', Message: '' } success - 1, error - 2
                mmsystem.ui.ajax.EventEmitter.emit('getCheckoutDetailsComplete', result);
            }
        });
    },

    SubmitEnquire: function (url, data) {
        //console.log("mmsystem.ui.ajax Order.SubmitEnquire...");
        $.ajax({
            url: url,
            type: "POST",
            dataType: "json",
            //contentType: "application/json; charset=utf-8",
            data: data,
            success: function (result) {

            },
            error: function (result) {
                mmsystem.ui.ajax.EventEmitter.emit("serverError", result);
            },
            complete: function (result) {
                // Add Event
                console.log('Emit "submitEnquireComplete" Event');
                //$(mmsystem.ui.ajax).trigger("orderUpdateComplete", result); // SimpleResult { Type: '0', Message: '' } success - 1, error - 2
                mmsystem.ui.ajax.EventEmitter.emit('submitEnquireComplete', result);
            }
        });
    },

    GetProductList: function (url, data) {
        //console.log("mmsystem.ui.ajax Order.SubmitEnquire...");
        $.ajax({
            url: url,
            type: "POST",
            //dataType: "html",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(data),
            success: function (result) {

            },
            error: function (result) {
                mmsystem.ui.ajax.EventEmitter.emit("serverError", result);
            },
            complete: function (result) {
                // Add Event
                // Build Simple Object result as this is NOT Json dataType but text
                mmsystem.ui.ajax.EventEmitter.emit('getProductListComplete', { Type: 1, Object: { RawHtml: result.responseText } });
            }
        });
    }
}


//Node exports
module.exports = mmsystem.ui.ajax;

// Hot Module Accept
if (module.hot) {
    module.hot.accept();
}